// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ actions
const cardRequestAdditionalActions = require('actions/contactCenter/cardRequestAdditional');

// @ components
const CardRequestAdditionalView = require('components/contactCenter/cardRequestAdditional/cardRequestAdditional');

class CardRequestAdditionalViewContainer extends React.Component {
    render() {
        return (
            <CardRequestAdditionalView {...this.props} />
        );
    }
}

CardRequestAdditionalViewContainer.propTypes = {
    immCards: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardRequestAdditional: PropTypes.object.isRequired,
    immPrinter:  PropTypes.object,
    queryRequestAdditionalCardData: PropTypes.func.isRequired,
    selectIntervener: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
}

module.exports.constructor = CardRequestAdditionalViewContainer;
module.exports.CardRequestAdditionalViewContainer = connect(
    state => ({
        immCards: state.cards,
        immAccounts: state.accounts,
        immPrinter: state.printer,
        immCardRequestAdditional: state.cardRequestAdditional,
    }),
    {
        queryRequestAdditionalCardData: cardRequestAdditionalActions.queryRequestAdditionalCardData,
        selectIntervener: cardRequestAdditionalActions.selectIntervener,
        validateStep: cardRequestAdditionalActions.validateStep,
        setVisibleStep: cardRequestAdditionalActions.setVisibleStep,
        handleFinish: cardRequestAdditionalActions.requestAdditionalCard,
        clearRequest: cardRequestAdditionalActions.clearRequest,
        clearValidationRequest: cardRequestAdditionalActions.clearValidationRequest
    }
)(CardRequestAdditionalViewContainer);
